import React from 'react';
import { BsDatabaseExclamation, BsFilterCircle, BsSearch } from 'react-icons/bs';

const EmptyState = ({ reason = "empty", title, description, actionLabel, onAction }) => {
    const presets = {
        empty: {
            icon: <BsDatabaseExclamation />,
            title: title || "No records yet",
            description: description || "There's nothing to display here yet.",
        },
        search: {
            icon: <BsSearch />,
            title: title || "No results found",
            description: description || "We couldn't find anything matching your search.",
        },
        filter: {
            icon: <BsFilterCircle />,
            title: title || "No results found",
            description: description || "Try adjusting or removing your filters.",
        },
    };
    const preset = presets[reason] || presets.empty;
    return (
        <div className="list-empty-state">
            <span className="list-empty-icon">{preset.icon}</span>
            <h6 className="list-empty-title">{preset.title}</h6>
            <p className="list-empty-desc">{preset.description}</p>
            {actionLabel && onAction ? (
                <button type="button" className="btn btn-primary btn-sm" onClick={onAction}>{actionLabel}</button>
            ) : ""}
        </div>
    );
};

export default EmptyState;
